import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export default function ScrollToTop() {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    if (hash) {
      const targetId = hash.replace('#', '')
      const element = document.getElementById(targetId)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
        return
      }
      // If element is not yet mounted (e.g. initial navigation)
      const timeout = setTimeout(() => {
        const delayedEl = document.getElementById(targetId)
        if (delayedEl) {
          delayedEl.scrollIntoView({ behavior: 'smooth' })
        }
      }, 100)
      return () => clearTimeout(timeout)
    }

    window.scrollTo(0, 0)
  }, [pathname, hash])

  return null
}
